import { INDICATOR_CONTAINER_ATTR } from './EnrichmentFieldIndicators.constants';

/**
 * Finds (or creates) a portal target <span> inside the field's <label>.
 * Keeps a registry so we can clean up orphaned nodes on unmount.
 */
const getOrCreateIndicatorTarget = (input, createdNodes) => {
  const formControl = input.closest('.MuiFormControl-root');

  if (!formControl) {
    return null;
  }

  const wrapper = formControl.parentElement;

  if (!wrapper) {
    return null;
  }

  const existingTarget = wrapper.querySelector(`[${INDICATOR_CONTAINER_ATTR}]`);

  if (existingTarget) {
    return existingTarget;
  }

  const label = wrapper.querySelector('label');

  if (!label) {
    return null;
  }

  const span = document.createElement('span');

  span.setAttribute(INDICATOR_CONTAINER_ATTR, 'true');
  span.style.display = 'inline-flex';
  span.style.alignItems = 'center';
  span.style.verticalAlign = 'middle';
  label.appendChild(span);
  createdNodes.push(span);

  return span;
};

/**
 * Removes all indicator portal nodes that were created by this component.
 */
export const removeCreatedNodes = createdNodes => {
  createdNodes.forEach(node => node.parentNode?.removeChild(node));
  createdNodes.length = 0;
};

/**
 * Scans the container for form fields matching the given enrichment field names,
 * and returns a map of fieldName → portal target element.
 */
export const findFieldTargets = (container, enrichmentFieldNames, createdNodes) => {
  const labels = {};

  enrichmentFieldNames.forEach(fieldName => {
    const input = container.querySelector(`[name="${fieldName}"]`);

    if (!input || input.disabled) {
      return;
    }

    const target = getOrCreateIndicatorTarget(input, createdNodes);

    if (target) {
      labels[fieldName] = target;
    }
  });

  return labels;
};
